<div class="wrapper-slider">
  <coin-v2-number-input
    [label]="label"
    [min]="0"
    [max]="100"
    [step]="0.5"
    [enforceStep]="true"
    [enforceMinMax]="true"
    [(ngModel)]="value" />
  <mat-slider
    class="cmsslider slider-cms"
    discrete
    [max]="100"
    [min]="0"
    [step]="0.5">
    <input
      matSliderThumb
      [(ngModel)]="value" />
  </mat-slider>
</div>
